import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../../components/signUp/createAccountAcademic/main"));


const AcademicSignUp = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default AcademicSignUp;